import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap5';

import Options from 'components/new_ui/Options/Options';
import Item from 'components/new_ui/Options/Item';
import CpaInfo from './CpaInfo';
import Steps from './Steps';

export default function Card({ template, options, children }) {
  const templateId = `template-${template.id}`;

  return (
    <div className="program-card d-flex flex-column h-100">
      <header className="mb-3">
        {options.length > 0 && (
          <Options>
            <>
              {options.map((option) => (
                <Item
                  key={`${templateId}-option-${option.iconClass}`}
                  title={option.title}
                  iconClass={option.iconClass}
                  onClick={option.onClick}
                />
              ))}
            </>
          </Options>
        )}

        <h5 className="me-5">
          {template.attributes.title}
        </h5>
      </header>

      <Row className="flex-grow-1 lh-lg">
        {template.attributes.type === 'CPA' ? (
          <CpaInfo templateId={templateId} />
        ) : (
          <Steps templateId={templateId} template={template} />
        )}

        <Col md="6">
          <div className="info d-flex flex-column h-100">
            <div className="mb-2 fw-semibold">Members</div>

            <div className="mb-2 d-flex justify-content-between">
              <div className="fw-light">
                Assigned
              </div>
              <div className="fw-semibold">
                {template.attributes.statistics.assigned}
              </div>
            </div>

            <div
              className={`mb-2 d-flex justify-content-between ${template.attributes.type === 'CPA' && 'text-muted'}`}
            >
              <div className="fw-light">
                In Progress
              </div>
              <div className="fw-semibold">
                {template.attributes.statistics.in_progress}
              </div>
            </div>

            <div className="mb-auto d-flex justify-content-between">
              <div className="fw-light">
                Completed
              </div>
              <div className="fw-semibold">
                {template.attributes.statistics.completed}
              </div>
            </div>

            {children && (
              <div className="d-flex justify-content-end pt-5">
                {children}
              </div>
            )}
          </div>
        </Col>
      </Row>
    </div>
  );
}

Card.propTypes = {
  template: PropTypes.object.isRequired,
  options: PropTypes.arrayOf(PropTypes.object),
  children: PropTypes.element,
};

Card.defaultProps = {
  options: [],
  children: null,
};
